import { RAG } from 'features/dashboard/charts/scoreColour'

export const COMPLIANCE_STATUS_BUCKETS = [
  { key: 'satisfied', label: 'Satisfied', tint: RAG.low.fg, help: 'Evidence is on file and in date, or the work was done in time.' },
  { key: 'inReview', label: 'In review', tint: RAG.medium.fg, help: 'Evidence has been submitted and is waiting for someone to approve it. It does not count yet.' },
  { key: 'pending', label: 'Pending', tint: RAG.high.fg, help: 'Nothing has been submitted for this obligation yet.' },
  { key: 'expired', label: 'Expired', tint: RAG.critical.fg, help: 'The evidence on file has run out of date.' },
  { key: 'skipped', label: 'Not applicable', tint: RAG.none.fg, help: 'Marked as not applying to this building, so it is left out of the score.' },
]

export const complianceBucketsFromRollup = rollup =>
  COMPLIANCE_STATUS_BUCKETS.map(b => ({
    ...b,
    count: Number(rollup?.[b.key] ?? rollup?.[b.key === 'inReview' ? 'in_review' : b.key] ?? 0),
  }))

export const complianceBucketTotal = rollup =>
  complianceBucketsFromRollup(rollup).reduce((sum, b) => sum + b.count, 0)
